module.exports = __webpack_public_path__ + "static/media/burgerAppS.1d97f36e.png";